import {
	MutationCache,
	QueryCache,
	QueryClient,
	QueryClientProvider,
} from "@tanstack/react-query";
import { toast } from "sonner";

const queryClient = new QueryClient({
	// queryCache: new QueryCache({
	// 	onError: (error) => {
	// 		toast.error(`API Error(Query): ${error.message}`);
	// 	},
	// }),
	// mutationCache: new MutationCache({
	// 	onError: (error) => {
	// 		toast.error(`API Error(Mutation): ${error.message}`);
	// 	},
	// }),
});

export function getContext() {
	return {
		queryClient,
	};
}

export function Provider({ children }: { children: React.ReactNode }) {
	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	);
}
